export default __webpack_public_path__ + "static/media/Snd_ClowerK.abe6dbcd.mp3";